import { Outlet } from "react-router-dom";

import { WrapperErrorBoundaryStyled } from "./styles";

const ErrorBoundaryLayout = () => {
  return (
    <WrapperErrorBoundaryStyled>
      <Outlet />
    </WrapperErrorBoundaryStyled>
  );
};

export default ErrorBoundaryLayout;
